<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-krahung">
      <div class="px-3 col-3 p-0">
        <div class="heading-krahung">{{ $t('result.round') }}</div>
        <div class="text-subhead-krahung">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-krahung">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-krahung">{{ data.bet | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-krahung">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-krahung">{{ data.winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-krahung">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-krahung">{{ data.balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-krahung pt-3">
      <div class="text-games-krahung">{{ 'Hungry Krahung' }}</div>
      <div class="text-subgame-krahung">{{ $t('krahung.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="table-krahung container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="i">
                  <img class="icon-symbol" :src="require(`../../assets/resultGame/krahung/symbol_${col}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="data.detail.winLines.length > 0" class="col-12 justify-content-center d-flex flex-row mt-3">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="data.detail.winLines.length > 0" class="col-12 justify-content-center d-flex flex-row mt-3">
        <div class="bet-box-krahung p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in symbolsDetail" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-krahung item">
                <div class="d-flex justify-content-start bet-wrapper-krahung item">
                  <img class="icon-detail-krahung"
                    :src="require(`../../assets/resultGame/krahung/symbol_${detail}.png`)" alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1" style="color: #ffc825;">{{ `${countSymbol[index]} ` + $t('result.kind') }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ `${currency} ${(data.detail.winInRows[index]).toFixed(2)}` }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="data.detail.bonusWin.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <div class="col-2"></div>
        <hr class="line">
        <div class="text-games-krahung align-items-center d-flex px-3">{{ $t('result.bonus') }}</div>
        <hr class="line">
        <div class="col-2"></div>
      </div>
      <div v-if="data.detail.bonusWin.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <div class="bonus-box p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in symbolsBonus" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-krahung item">
                <div class="d-flex justify-content-start bet-wrapper-krahung item">
                  <img class="icon-bonus-krahung" :src="require(`../../assets/resultGame/krahung/bonus_symbol.png`)"
                    alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `Got Bonus ${detail.index + 1}` }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.bonusWin | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-krahung',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 4, 7, 10, 13,],
        [2, 5, 8, 11, 14,],
        [3, 6, 9, 12, 15,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      // result: this.data,
      count: this.data.count,
      countSymbol: [],
      symbolsDetail: [],
      bonusGames: false,
      symbolsBonus: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    await this.mapSymbol()
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-krahung')[0].offsetHeight
    },
    mapSymbol() {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.table[0][0] = this.data.detail.numbers[0]
      this.table[1][0] = this.data.detail.numbers[1]
      this.table[2][0] = this.data.detail.numbers[2]
      this.table[0][1] = this.data.detail.numbers[3]
      this.table[1][1] = this.data.detail.numbers[4]
      this.table[2][1] = this.data.detail.numbers[5]
      this.table[0][2] = this.data.detail.numbers[6]
      this.table[1][2] = this.data.detail.numbers[7]
      this.table[2][2] = this.data.detail.numbers[8]
      this.table[0][3] = this.data.detail.numbers[9]
      this.table[1][3] = this.data.detail.numbers[10]
      this.table[2][3] = this.data.detail.numbers[11]
      this.table[0][4] = this.data.detail.numbers[12]
      this.table[1][4] = this.data.detail.numbers[13]
      this.table[2][4] = this.data.detail.numbers[14]

      let number = this.data.detail.numbers
      let winline = this.data.detail.winLines
      let line = this.data.game.config.betLines

      let sum = [...winline.map(() => (
        []
      ))]

      winline.forEach((v, i) => {
        line[v].forEach((w) => {
          sum[i].push(number[w])
        })
      })

      sum.forEach((v) => {
        let first = v[0];
        let count = 0;
        v.forEach((sym, i) => {
          if ((sym === first || sym === 7) && i === count) count++;
          else return count
        })
        this.countSymbol.push(count)
        this.symbolsDetail.push((v)[0])
      })
      this.symbolsBonus = this.data.detail.bonusWin

      if (this.data.detail.isCoin) this.currency = 'AMS';
    },
  }
}
</script>

<style scoped>
.icon-detail-krahung {
  width: 85px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-krahung {
  width: 100px;
  height: 200px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-krahung {
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-krahung {
  background: #2e6e4a;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-krahung .item {
  color: #fff;
  background: #2e6e4a;
  line-height: 1;
  border-radius: 10px;
  border: 1.9px solid #000;
}

.bet-box-krahung .bet-wrapper-krahung:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-krahung,
.result-wrapper {
  font-size: 35px;
}

.header-krahung {
  background: #ffc825;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-krahung>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-krahung {
  color: #000;
  font-weight: bold;
  text-align: center;
}

.content-result-krahung {
  background: #032123;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-krahung {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-krahung {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-krahung {
  font-size: px;
  color: #000;
  text-align: center;
}

.text-subgame-krahung {
  font-size: 20px;
  color: #fb820b;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-krahung {
  min-width: 600px;
  max-width: auto;
}

.table-krahung {
  background: url('~@/assets/resultGame/krahung/board_info.png') no-repeat;
  background-size: 580px 470px;
  padding-top: 45px;
  width: 580px;
  height: 470px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-krahung {
    background-size: 500px 400px;
    width: 500px;
    height: 380px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-krahung {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-krahung,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-krahung,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-krahung {
    font-size: 18px;
  }

  .table-krahung {
    background-size: 470px 420px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-krahung {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-krahung {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header-krahung>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-krahung {
    font-size: 12px;
  }

  .table-krahung {
    background-size: 260px 190px;
    width: 260px;
    padding-top: 20px;
    height: 190px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-krahung {
    font-size: 14px;
  }

  .bet-box-krahung {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-krahung,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-krahung {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-krahung {
    width: 45px;
    height: 90px;
    margin-right: 5px;
    margin-left: 5px;
  }
}

.text-black {
  color: #000;
}
</style>